<div class="register__page">
  <div class="main--wrapper">
    <!-- Logo -->
    <header>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="auth-section--logo">
              <a role="button" [href]="commonService.landingUrl">
                <img [src]="commonService?.getOrgWindowObject?.LOGO_URL ? commonService?.getOrgWindowObject?.LOGO_URL : 'assets/images/logo.png'"
                onerror="this.src='assets/images/logo.png';" class="cursor-pointer" alt="Logo">
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!-- Form -->
    <div class="container" *ngIf="!showSuccessPage">
      <div class="auth-box--wrapper position-relative" *ngIf="isCodeValid">
        <!-- STEP 1 -->
        <ng-container *ngIf="stepNumber == 1">
          <form [formGroup]="personalInfoForm" autocomplete="off">
            <div class="mb-50">
              <div class="auth-box--title">Personal Information</div>
              <div class="auth-box--description">
                Your information will never be published and will stay secure. This info is used for the PDF report
                creation
              </div>
            </div>
            <div>

              <!-- Email -->
              <div class="mb-15" *ngIf="user?.EMAIL">
                <label class="field-label">Email</label>
                <input class="input input__large input__blue" [value]="user.EMAIL" disabled>
              </div>

              <!-- First Name -->
              <div class="mb-15" [ngClass]="{'error-block': checkPersonalInfoControlValid('firstName')}">
                <label class="field-label">First Name</label>
                <input type="text" class="input input__large input__blue" formControlName="firstName"
                  placeholder="First Name" validateSpaceReactive maxlength="50" alphabetWithSpaceOnlyReactive
                  [ngClass]="{'error-input' : checkPersonalInfoControlValid('firstName')}">
                <ng-container *ngIf="checkPersonalInfoControlValid('firstName')">
                  <div class="error-text">Please enter first name</div>
                </ng-container>
              </div>

              <!-- Last Name -->
              <div class="mb-15" [ngClass]="{'error-block': checkPersonalInfoControlValid('lastName')}">
                <label class="field-label">Last Name</label>
                <input type="text" class="input input__large input__blue" placeholder="Last Name"
                  formControlName="lastName" validateSpaceReactive maxlength="50" alphabetWithSpaceOnlyReactive
                  [ngClass]="{'error-input' : checkPersonalInfoControlValid('lastName')}">
                <ng-container *ngIf="checkPersonalInfoControlValid('lastName')">
                  <div class="error-text">Please enter last name</div>
                </ng-container>
              </div>

              <!-- Phone Number -->
              @if (!user?.REQUIRE_PASS_NO_REGISTER){
                <div class="mb-15" [ngClass]="{'error-block': checkPersonalInfoControlValid('phone')}">
                  <label class="field-label">Phone Number</label>
                  <input type="text" class="input input__large input__blue" placeholder="000-000-0000"
                    formControlName="phone" phoneNumber autocomplete="new-password"
                    [ngClass]="{'error-input' : checkPersonalInfoControlValid('phone')}">
                  <ng-container *ngIf="checkPersonalInfoControlValid('phone')">
                    <div class="error-text">Please enter valid phone number.</div>
                  </ng-container>
                </div>
              }

               <ng-container *ngIf="!hasPassword">
                <div class="mb-15" [ngClass]="{'error-block': checkPersonalInfoControlValid('password')}">
                  <label class="field-label">Password</label>
                  <input type="password" class="input input__large input__blue" placeholder="at least 8 characters"
                    formControlName="password" maxlength="50"
                    [ngClass]="{'error-input' : checkPersonalInfoControlValid('password')}">
                  <ng-container *ngIf="checkPersonalInfoControlValid('password')">
                    <div class="error-text">Password must be at least 8 characters with at least 1 number and 1 special character (&#64;, $, !, %, *, #, ?, &)</div>
                  </ng-container>
                </div>
              </ng-container>

              <!--  -->
              <!--<div class="mb-15 radio__group">
                <label class="field-label">Will you be performing the valuation on another company's behalf?</label>

                <label class="checkbox large m-0">
                  <input type="radio" name="customRadioInline" class="checkbox__input" [value]="true"
                    formControlName="isOtherCompany" (change)="isCompanyChange(true)">
                  <div class="checkbox__data">
                    <div class="checkbox__indicator"></div>
                    <p class="checkbox__text">
                      Yes
                    </p>
                  </div>
                </label>
                <label class="checkbox large m-0 ml-3">
                  <input type="radio" name="customRadioInline" class="checkbox__input" [value]="false"
                    formControlName="isOtherCompany" (change)="isCompanyChange(false)">
                  <div class="checkbox__data">
                    <div class="checkbox__indicator"></div>
                    <p class="checkbox__text">
                      No
                    </p>
                  </div>
                </label>
              </div>-->

              <!--<ng-container *ngIf="personalInfoForm.value.isOtherCompany">-->
                <!-- Organization Name -->
                <div class="mb-15" [ngClass]="{'error-block': checkPersonalInfoControlValid('orgName')}">
                  <label class="field-label">Company Name</label>
                  <input type="text" class="input input__large input__blue" placeholder="Company Name"
                    formControlName="orgName" validateSpaceReactive maxlength="50"
                    [ngClass]="{'error-input' : checkPersonalInfoControlValid('orgName')}">
                  <ng-container *ngIf="checkPersonalInfoControlValid('orgName')">
                    <div class="error-text">Please enter organization name.</div>
                  </ng-container>
                </div>

                <!-- What do you do -->
                <!--<div class="mb-15">
                  <label class="field-label">What do you do?</label>
                  <app-custom-select #whatYouDo="ngModel" [(ngModel)]="whatDoYouDo" [values]="businessType"
                    placeholder="Choose one (if applicable)" name="whatYouDo" (valueSelected)="changeEvent($event)">
                  </app-custom-select>

                  <input type="hidden" id="whatDoYouDoHdn" formControlName="whatYouDo">
                </div>-->
              <!--</ng-container>-->

              @if (user?.REQUIRE_PASS_NO_REGISTER){
                <form [formGroup]="addressForm" autocomplete="off">
                  <div class="mb-15 mt-15">
                    <label class="checkbox agree-checkbox m-0">
                      <input type="checkbox" name="IS_AGREE" class="checkbox__input" [value]="true"
                             formControlName="isAgree">
                      <div class="checkbox__data pl-0 pt-0">
                        <div class="checkbox__indicator"></div>
                        <p class="checkbox__text">
                          By registering you agree to our
                          <a class="color--blue" href="/privacy" target="_blank">privacy policy</a>,&nbsp;
                          <a class="color--blue" href="/license" target="_blank">license</a> &
                          <a class="color--blue" href="/tos" target="_blank">terms and conditions</a>
                        </p>
                      </div>
                    </label>
                    <p class="font-size-13 color--gray--2 mb-1">
                      We will never sell or disclose, nor permit access to, Non-public Personal Information for any purpose other than as specifically required to fulfill our contractual obligations with you.
                    </p>
                  </div>
                </form>
              }

              <!-- Continue -->
              <div class="mt-40">
                @if (!user?.REQUIRE_PASS_NO_REGISTER){
                  <button type="button" class="button primary__button large__button font-size-18 px-5"
                    (click)="personalSave()" [disabled]="!personalInfoForm.valid">
                    Continue
                  </button>
                } @else {
                  <button type="button" class="button primary__button large__button font-size-18 px-5"
                          (click)="addressSave()" [disabled]="!personalInfoForm.valid || !addressForm.valid">
                    Finish Registration
                  </button>
                }
              </div>
            </div>
          </form>
        </ng-container>

        <!-- STEP 2 -->
        <div class="signup-step--wrapper" *ngIf="stepNumber == 2">
          <form [formGroup]="addressForm" autocomplete="off">
            <div class="mb-50">
              <div class="auth-box--title">Address Information</div>
              <div class="auth-box--description">
                Your information will stay secure. This info is used for the PDF report creation.
              </div>
            </div>

            <div>
              <!-- Address -->
              <div class="mb-15" [ngClass]="{'error-block': checkControlValid('address1')}">
                <div class="d-flex justify-content-between">
                  <label class="field-label">Address</label>
                  <div class="color--light--gray font-size-14 font-weight-bold">Optional</div>
                </div>
                <input type="text" class="input input__large input__blue" formControlName="address1"
                  placeholder="Address" [ngClass]="{'error-input' : checkControlValid('address1')}">
                <ng-container *ngIf="checkControlValid('address1')">
                  <div class="error-text">Please enter address.</div>
                </ng-container>
              </div>

              <div class="row" [ngClass]="{'error-block': checkControlValid('city') || checkControlValid('zip')}">
                <!-- City -->
                <div class="col-12 col-sm-12 col-md-7 col-lg-8 col-xl-8">
                  <div>
                    <div class="d-flex justify-content-between">
                      <label class="field-label">City</label>
                      <div class="color--light--gray font-size-14 font-weight-bold">Optional</div>
                    </div>
                    <input type="text" class="input input__large input__blue" formControlName="city" placeholder="Autofilled based on Zip Code"
                       disabled [ngClass]="{'error-input' : checkControlValid('city')}">
                  </div>
                </div>

                <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                  <div>
                    <div class="d-flex justify-content-between">
                      <label class="field-label">Zip Code</label>
                      <div class="color--light--gray font-size-14 font-weight-bold">Optional</div>
                    </div>
                    <input type="text" class="input input__large input__blue" formControlName="zip" placeholder="Zip Code"
                      numbersOnly maxlength="5" (ngModelChange)="getAddressInfo()"
                      [ngClass]="{'error-input' : checkControlValid('zip')}">
                  </div>
                </div>

                <!-- Validation -->
                <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4"
                  *ngIf="checkControlValid('city') || checkControlValid('zip')">
                  <ng-container *ngIf="checkControlValid('city')">
                    <div class="error-text">Please enter city.</div>
                  </ng-container>
                  <ng-container *ngIf="checkControlValid('zip')">
                    <div class="error-text">Please enter valid zip code.</div>
                  </ng-container>
                </div>

              </div>

              <!-- State -->
              <div class="mb-15 mt-15">
                <div class="d-flex justify-content-between">
                  <label class="field-label">State</label>
                  <div class="color--light--gray font-size-14 font-weight-bold">Optional</div>
                </div>
                <input type="text" class="input input__large input__blue" formControlName="state" placeholder="Autofilled based on Zip Code"
                  disabled [ngClass]="{'error-input' : checkControlValid('state')}">
                <ng-container *ngIf="checkControlValid('state')">
                  <div class="error-text">Please enter state.</div>
                </ng-container>
              </div>

              <!-- Promo code -->
              <div class="mb-15 mt-15" *ngIf="user.BUSINESS_TYPE === BusinessType.BROKER">
                <div class="mb-15" [ngClass]="{'error-block': isValidPromo === false && addressForm.get('PROMO_CODE')?.value}">
                  <div class="field-label">Promo Code</div>
                  <input type="text" class="input input__blue input__large"
                          formControlName="PROMO_CODE"
                         [ngClass]="{'error-input': isValidPromo === false && addressForm.get('PROMO_CODE')?.value}"
                         #txtPromo name="txtPromo" maxlength="50" id="txtPromo"
                         placeholder="Promo Code">
                  <div *ngIf="isValidPromo === false && addressForm.get('PROMO_CODE')?.value">
                    <div class="error-text">Promo Code is Invalid</div>
                  </div>
                </div>
                <div *ngIf="isValidPromo === false" class="invalid-promo-text">Enter a Promo Code to avoid paying $300 to unlock the report</div>
                <div *ngIf="isValidPromo === true && addressForm.get('PROMO_CODE')?.value" class="valid-promo-text">Promo is golden, you have now everything free</div>
              </div>

              <div class="mb-15 mt-15">
                <label class="checkbox agree-checkbox m-0">
                  <input type="checkbox" name="IS_AGREE" class="checkbox__input" [value]="true"
                         formControlName="isAgree">
                  <div class="checkbox__data pl-0 pt-0">
                    <div class="checkbox__indicator"></div>
                    <p class="checkbox__text">
                      By registering you agree to our
                      <a class="color--blue" href="/privacy" target="_blank">privacy policy</a>,&nbsp;
                      <a class="color--blue" href="/license" target="_blank">license</a> &
                      <a class="color--blue" href="/tos" target="_blank">terms and conditions</a>
                    </p>
                  </div>
                </label>
                <p class="font-size-13 color--gray--2 mb-1">
                  We will never sell or disclose, nor permit access to, Non-public Personal Information for any purpose other than as specifically required to fulfill our contractual obligations with you.
                </p>
                <!--<p class="font-size-14 color&#45;&#45;gray&#45;&#45;2">
                  By clicking the Register button, you agree to the <a class="color&#45;&#45;blue" href="/license" target="_blank">License Agreement</a> (no payment due)
                </p>-->
              </div>

              <!-- Finish Registration -->
              <div class="mt-40 d-flex justify-content-between flex-wrap w-100">
                <button class="button primary__button large__button font-size-18 px-5 finesh-button" (click)="addressSave()"
                  [disabled]="!addressForm.valid || checkingPromo">Finish Registration</button>

                <button type="button" class="button large__button ghost__button font-size-18 back-button" (click)="goBack()">
                  <svg class="mr-2" width="25" height="24" viewBox="0 0 25 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.5 11.999H22.5H4.5Z" fill="var(--primary-color)" />
                    <path d="M4.5 11.999H22.5" stroke="var(--primary-color)" stroke-width="2" stroke-miterlimit="10"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M11.5 5L4.5 12L11.5 19" stroke="var(--primary-color)" stroke-width="2" stroke-miterlimit="10"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span class="ml-2">Back</span>
                </button>
              </div>
            </div>
          </form>
        </div>

      </div>
      <div *ngIf="!isCodeValid" class="alert alert-danger text-center">
        <strong>Invalid Code</strong> <br>
        You have used expired link , user already register please use login.
      </div>
    </div>

    <div class="container" *ngIf="showSuccessPage">
      <div class="position-relative">
        <div class="blueish-bg">
          <div class="shade upper"></div>
          <div class="shade lower"></div>
        </div>
        <div class="signup--content">
          <div class="signup--contentBox success-box">
            <div>
              <svg-icon name="email_sent"></svg-icon>
            </div>
            <div class="mt-50 mb-10">
              <h4 class="signup--contentTitle mb-0">Thank you for registering, we're building your custom dashboard in just a few seconds!</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
